import React, { useState } from 'react';
import { MerchantDetail } from './MerchantDetail';
import { useGetMerchant, useMerchantsWithOuName } from '@app/sdk';
import { ContentHeader, Error, Table } from '@app/shared';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';
import { UpdateConfig } from '../updateConfig/UpdateConfig';
import { AddConfig } from '../addConfig/AddConfig';

export function Merchants() {
  const [selectedMerchantId, setSelectedMerchantId] = useState(undefined as any);
  const [isUpdateConfig, setIsUpdateConfig] = useState(false);
  const [isAddConfig, setIsAddConfig] = useState(false);

  const { isLoading, error, data: merchants } = useMerchantsWithOuName();
  const { data: selectedMerchant } = useGetMerchant({ id: selectedMerchantId });

  const colDefs: ColDef[] = [
    { field: 'merchantId', headerName: 'ID' },
    { field: 'name', headerName: 'Name' },
    { field: 'organisationUnitName', headerName: 'OU Name' },
  ];

  const master = (
    <Segment style={{ height: '100%' }}>
      <ContentHeader>
        Merchants
        <div>
          <button
            disabled
            className="ui button primary"
            onClick={() => {
              setIsAddConfig(true);
              setIsUpdateConfig(false);
            }}>
            Add Config
          </button>
          <button
            disabled
            className="ui button primary"
            onClick={() => {
              setIsUpdateConfig(true);
              setIsAddConfig(false);
            }}>
            Edit Config
          </button>
        </div>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 70px)' }}>
        <Table
          items={merchants}
          onSelectItem={(merchant) => setSelectedMerchantId(merchant.merchantId)}
          columnDefs={colDefs}
        />
      </div>
    </Segment>
  );

  const updateConfig = (
    <Segment>
      <UpdateConfig
        key={selectedMerchantId}
        enableEditConfig={setIsUpdateConfig}
        item={selectedMerchant}
        type={'merchant'}
      />
    </Segment>
  );

  const addConfig = (
    <Segment>
      <AddConfig key={selectedMerchantId} enableAddConfig={setIsAddConfig} item={selectedMerchant} type={'merchant'} />
    </Segment>
  );

  const merchantDetail = (
    <Segment>
      {selectedMerchantId ? (
        <MerchantDetail merchant={selectedMerchant} />
      ) : (
        <section>Please select a merchant</section>
      )}
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      {error && <Error error={error} />}
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && merchants && (
        <MasterDetailLayout
          master={master}
          detail={isUpdateConfig ? updateConfig : isAddConfig ? addConfig : merchantDetail}
        />
      )}
    </ComponentErrorBoundary>
  );
}
